import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

/**
 * Build a server-side redirect URL that increments the click counter and
 * then 302-redirects to the real destination (Telegram, WhatsApp, IG, ...).
 * Using this as the anchor `href` avoids all client-side pitfalls
 * (in-app browsers, popup blockers, CORS preflight blocking navigation).
 */
export function goUrl(kind) {
  return `${API}/go/${encodeURIComponent(kind)}`;
}

export function formatApiError(detail) {
  if (detail == null) return "Errore imprevisto. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// Legacy fire-and-forget counter (kept for any leftover callers).
export function trackClick(kind) {
  try {
    const url = `${API}/track/click`;
    const payload = JSON.stringify({ kind });
    if (typeof navigator !== "undefined" && navigator.sendBeacon) {
      const blob = new Blob([payload], { type: "text/plain" });
      navigator.sendBeacon(url, blob);
      return;
    }
    fetch(url, {
      method: "POST",
      headers: { "Content-Type": "text/plain" },
      body: payload,
      keepalive: true,
    }).catch(() => {});
  } catch (e) {
    // silent
  }
}
